import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, authLoading] = useAuthState(auth);
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;

    if (!user) {
      setUserRole(null);
      setRoleLoading(false);
      return;
    }

    const fetchRole = async () => {
      try {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserRole(docSnap.data().role);
        } else {
          // No users doc: treat as editor for backward compatibility
          setUserRole("editor");
        }
      } catch {
        setUserRole("editor");
      } finally {
        setRoleLoading(false);
      }
    };

    fetchRole();
  }, [user, authLoading]);

  return (
    <AuthContext.Provider
      value={{ user, userRole, loading: authLoading || roleLoading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthProvider;
